import { t, tf } from "./i18n.js";
import { erzeugeAufnahmeEingabe, istCheckoutDart, letzterDart } from "./aufnahme-eingabe.js";
window.player121 = null;
let currentTarget121 = 121;
let currentScore121 = 121;
let bestTarget121 = 121;
let dartsThrown121 = 0;
// Aufnahmen im laufenden Level. NEU (14.08.2026) und noetig, seit die
// Dartzahl echt ist: Das Level endet nach DREI Aufnahmen. Bliebe die
// Bedingung `dartsThrown121 >= 9`, haette ein Level mit einer 2-Dart-
// Aufnahme (Bust mit dem zweiten Pfeil, Rest weggelegt) bei 8 Darts kein
// Ende mehr gefunden.
let visits121 = 0;
// Echte Dartzahl ueber alle Level - fuer die Statistik. Vorher stand dort
// `matchLog121.length * 3`, also die Annahme statt der Zaehlung.
let dartsGesamt121 = 0;
let useSafePoints121 = true;
let history121Stack = []; // Für den Undo-Button
let matchLog121 = []; // Für den visuellen Verlauf
// FIX: Startziel wird beim Spielstart eingefroren. Vorher wurde es bei jedem
// Level-Verlust frisch aus dem Setup-Feld gelesen -> leeres Feld ergab NaN.
let startTarget121 = 121;
// FIX: Handle fuer den Level-Wechsel-Timer, damit Undo ihn abbrechen kann.
window.levelTimer121 = null;
// Zaehler fuer die Statistik (stats_121)
let levelsWon121 = 0;
let levelsLost121 = 0;

function start121Game() {
  const name =
    document.getElementById("player-121-input").value.trim() || t("js.app.009");
  const startTarget =
    parseInt(document.getElementById("start-target-121").value) || 121;
  useSafePoints121 = document.getElementById("chk-121-safe-points").checked;

  player121 = name;
  startTarget121 = startTarget;
  currentTarget121 = startTarget;
  bestTarget121 = startTarget;

  if (levelTimer121) {
    clearTimeout(levelTimer121);
    levelTimer121 = null;
  }

  resetLevel121();

  history121Stack = [];
  matchLog121 = [];
  levelsWon121 = 0;
  levelsLost121 = 0;
  dartsGesamt121 = 0;

  document.getElementById("btn-undo-121").style.display = "none";
  document.getElementById("setup-121-screen").style.display = "none";
  document.getElementById("game-121-screen").style.display = "block";

  // ERST sichtbar, DANN bauen - createDartboard misst beim Zeichnen.
  eingabe121.baue();
  eingabe121.leere();
  eingabe121.aktualisiereSichtbarkeit();

  update121UI();
}

function cancel121Game() {
  // Fortschritt sichern, bevor der Screen zugeht
  save121StatsBackground();
  cancelCurrentGame("game-121-screen");
}

// Speichert den Durchgang im Hintergrund (Tabelle: supabase/stats_121.sql)
async function save121StatsBackground() {
  if (!player121 || matchLog121.length === 0) return;
  try {
    const payload = {
      name: player121,
      start_target: startTarget121,
      best_target: bestTarget121,
      levels_won: levelsWon121,
      levels_lost: levelsLost121,
      // Echte Dartzahl statt `matchLog121.length * 3` (offener Punkt D4).
      darts_thrown: dartsGesamt121,
      safe_points: useSafePoints121,
      details: matchLog121,
    };
    if (typeof currentUser !== "undefined" && currentUser) {
      payload.user_id = currentUser.id;
    }

    const { error } = await _supabase.from("stats_121").insert([payload]);
    if (error) {
      console.error(t("js.g121.001"), error.message);
    }
  } catch (err) {
    console.error(t("js.g121.002"), err);
  }
}

function resetLevel121() {
  currentScore121 = currentTarget121;
  dartsThrown121 = 0;
  visits121 = 0;
  if (eingabe121) eingabe121.leere();
}

/** Eine Aufnahme werten.
 *
 *  @param {number} score      Summe der Aufnahme
 *  @param {Array|number} [wuerfe] Dartliste des Bausteins - oder nur die
 *                             Anzahl (alter Aufrufer/Test). Fehlt beides,
 *                             bleibt es bei drei Darts.
 *  @returns {boolean} false = abgelehnt, der Baustein laesst die Darts stehen. */
function submit121Score(score, wuerfe) {
  score = Number(score);
  if (!Number.isFinite(score)) return false;

  if (score > 180) {
    showToast(t("js.g121.003"), "warning");
    return false;
  }

  const liste = Array.isArray(wuerfe) ? wuerfe : null;
  const dartZahl = liste
    ? liste.length || 3
    : Number.isFinite(wuerfe) && wuerfe > 0
      ? wuerfe
      : 3;

  // Snapshot für Undo
  history121Stack.push({
    target: currentTarget121,
    score: currentScore121,
    darts: dartsThrown121,
    visits: visits121,
    gesamt: dartsGesamt121,
    best: bestTarget121,
    logLength: matchLog121.length,
  });
  document.getElementById("btn-undo-121").style.display = "block";

  let oldScore = currentScore121;
  let newScore = currentScore121 - score;
  let isBust = false;

  // Bust-Logik (Double-Out-Pflicht).
  //
  // BEFUND 14.08.2026: Der Kommentar stand hier schon, die Pruefung nicht.
  // Mit dem Ziffernblock war sie auch nicht moeglich - eine getippte "121"
  // verraet nicht, womit ausgemacht wurde. Uebrig blieb der Rest-1-Bust,
  // der aus der Double-Out-Regel FOLGT, ohne sie durchzusetzen: Ein Finish
  // per Single zaehlte als Sieg.
  //
  // Seit die Aufnahme aus einzelnen Darts besteht, ist die Regel pruefbar,
  // und sie wird durchgesetzt. Ohne Dartliste (alter Aufrufer, Test) bleibt
  // es beim alten, milderen Verhalten - stillschweigend haerter zu werten,
  // waere schlimmer als die Luecke.
  if (newScore < 0 || newScore === 1) {
    newScore = currentScore121;
    isBust = true;
  } else if (newScore === 0 && liste && !istCheckoutDart(letzterDart(liste))) {
    newScore = currentScore121;
    isBust = true;
  }

  // Darts addieren
  dartsThrown121 += dartZahl;
  dartsGesamt121 += dartZahl;
  visits121 += 1;
  currentScore121 = newScore;

  // Historie für die UI
  matchLog121.push({
    level: currentTarget121,
    old: oldScore,
    thrown: isBust ? t("js.g121.006") : score,
    new: newScore,
  });

  // Check Win/Loss Bedingungen. Das Level laeuft ueber DREI Aufnahmen -
  // nicht ueber neun gezaehlte Darts, siehe Kommentar bei visits121.
  if (newScore === 0) {
    handleLevelWin121();
  } else if (visits121 >= 3) {
    handleLevelLoss121();
  } else {
    update121UI();
  }
  return true;
}

function handleLevelWin121() {
  showToast(tf("js.g121.004", { p1: currentTarget121 }), "success");

  levelsWon121++;
  currentTarget121++;
  if (currentTarget121 > bestTarget121) bestTarget121 = currentTarget121;

  scheduleLevelReset121(1000);
}

function handleLevelLoss121() {
  levelsLost121++;
  let dropTarget = currentTarget121 - 1;

  if (useSafePoints121) {
    // Fällt zurück auf den letzten durch 5 teilbaren Wert (Safe Point)
    let safePoint = Math.floor(currentTarget121 / 5) * 5;
    if (currentTarget121 % 5 === 0) {
      safePoint = currentTarget121 - 5; // Wenn man auf 125 verliert, fällt man auf 120
    }
    // FIX: gespeichertes Startziel statt DOM-Wert -> kein NaN mehr moeglich.
    dropTarget = Math.max(safePoint, startTarget121);
  }

  // Unter das Startziel darf es nie fallen
  dropTarget = Math.max(dropTarget, startTarget121);

  showToast(tf("js.g121.005", { p1: dropTarget }), "error");
  currentTarget121 = dropTarget;

  scheduleLevelReset121(1500);
}

// FIX: Zentraler Timer mit Handle. Vorher konnte ein Undo innerhalb der
// Wartezeit vom nachfolgenden setTimeout wieder ueberschrieben werden.
function scheduleLevelReset121(delay) {
  if (levelTimer121) clearTimeout(levelTimer121);
  levelTimer121 = setTimeout(() => {
    levelTimer121 = null;
    resetLevel121();
    update121UI();
  }, delay);
}

function undo121Turn() {
  if (history121Stack.length === 0) return;

  // FIX: Laufenden Level-Wechsel abbrechen, sonst ueberschreibt der Timer
  // gleich darauf die wiederhergestellten Werte.
  if (levelTimer121) {
    clearTimeout(levelTimer121);
    levelTimer121 = null;
  }

  const last = history121Stack.pop();

  currentTarget121 = last.target;
  currentScore121 = last.score;
  dartsThrown121 = last.darts;
  visits121 = last.visits ?? 0;
  dartsGesamt121 = last.gesamt ?? 0;
  bestTarget121 = last.best;

  matchLog121 = matchLog121.slice(0, last.logLength);

  if (history121Stack.length === 0) {
    document.getElementById("btn-undo-121").style.display = "none";
  }

  // Die Kacheln gehoeren zur zurueckgenommenen Aufnahme.
  eingabe121.leere();
  update121UI();
}

function update121UI() {
  document.getElementById("player-121-name").innerText = player121;
  document.getElementById("target-121-display").innerText = currentTarget121;
  document.getElementById("current-score-121").innerText = currentScore121;
  document.getElementById("best-target-121").innerText = bestTarget121;
  document.getElementById("darts-thrown-121").innerText =
    `${dartsThrown121} / 9`;

  // Checkout Path (Nutzt Funktion aus game-501.js)
  const checkoutPath =
    typeof getCheckoutPath === "function"
      ? getCheckoutPath(currentScore121)
      : "";
  document.getElementById("checkout-path-121").innerText = checkoutPath
    ? tf("js.g121.007", { p1: checkoutPath })
    : "";

  eingabe121.aktualisiereZiel();
  eingabe121.zeichne();
  update121HistoryUI();
}

function update121HistoryUI() {
  const list = document.getElementById("history-list-121");
  list.innerHTML = "";

  // Neueste oben
  let displayLog = [...matchLog121].reverse();

  displayLog.forEach((t) => {
    list.innerHTML += `
      <div style="display:flex; justify-content:space-between; padding:8px 10px; background:rgba(255,255,255,0.03); margin-bottom:5px; border-radius:6px; font-size: 0.9em; border-left: 3px solid var(--accent-blue);">
        <span>Level ${t.level}: ${t.old} &rarr; <b style="color:white;">${t.new}</b></span>
        <span style="color:var(--accent-blue); font-weight:bold;">[${t.thrown}]</span>
      </div>
    `;
  });
}

// ---------------------------------------------------------------------------
// EINGABE (14.08.2026, Stufe 3): drei Darts statt einer getippten Summe
//
// Catch 121 hatte einen Ziffernblock - die Aufnahme wurde als EINE Zahl
// eingegeben. Damit ging verloren, welche Felder getroffen wurden, und der
// Tracker konnte nur ueber den Umweg "Summe zusammenrechnen" andocken. Die
// Wertung (Double-Out-Bust, Level rauf/runter) bleibt unveraendert in
// submit121Score(); der Baustein liefert nur Summe und Dartzahl.
// ---------------------------------------------------------------------------
const eingabe121 = erzeugeAufnahmeEingabe({
  modus: "121",
  ziel: () => document.getElementById("aufnahme-121"),
  aktiv: () =>
    document.getElementById("game-121-screen")?.style.display !== "none" &&
    Boolean(player121),
  // Waehrend der Level-Pause (scheduleLevelReset121) ist das Level schon
  // entschieden - ein weiterer Dart wuerde gegen den naechsten Stand
  // gerechnet. Der Tracker darf trotzdem melden (siehe nimmDart).
  gesperrt: () => Boolean(levelTimer121),
  // Das Finish-Doppel hervorheben, sobald es eines gibt - dieselbe Regel
  // wie bei Random Checkout und beim OBS-Zoom.
  zielFelder: () => {
    const rest = currentScore121;
    if (rest === 50) return [{ base: 50 }];
    if (rest <= 40 && rest >= 2 && rest % 2 === 0) return [{ base: rest / 2, mult: 2 }];
    return [];
  },
  // Die ganze Liste, nicht nur ihre Laenge: submit121Score braucht den
  // LETZTEN Dart, um die Double-Out-Pflicht zu pruefen.
  onAufnahme: (wuerfe, summe) => submit121Score(summe, wuerfe),
});

// ---------------------------------------------------------------
// Bruecke zu window: Inline-Handler im HTML und andere Module greifen
// weiterhin global auf diese Funktionen zu. Automatisch erzeugt beim
// Umstieg auf Vite - Modul-Scope ersetzt sonst die alten Globals.
// ---------------------------------------------------------------
Object.assign(window, {
  start121Game,
  cancel121Game,
  submit121Score,
  undo121Turn,
  eingabe121,
});
